import Vue from 'vue';
import Vuex from 'vuex';
import HomeModule from './modules/home';
import DetailsModule from './modules/details';
import VideoModule from './modules/video';
import RegisterModule from './modules/register';
import LoginModule from './modules/login';
import ForgetModule from './modules/forget';
import InfoModule from './modules/info';
import wxLoginModule from './modules/wxlogin';
import PayModule from './modules/pay';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
	HomeModule,
  DetailsModule,
  VideoModule,
  RegisterModule,
  LoginModule,
  ForgetModule,
  InfoModule,
  wxLoginModule,
  PayModule
  }
})
